import React from 'react';

const RefundPolicy = () => {
  return (
    <div style={{ padding: '40px 20px', maxWidth: '800px', margin: '0 auto', color: '#333', lineHeight: '1.6' }}>
      <h1>Правила возврата средств</h1>
      <p>Последнее обновление: 15 июля 2026 г.</p>
      <p>Пожалуйста, ознакомьтесь с правилами совершения платежей и возврата средств на платформе <strong>REALWORK</strong>.</p>
      
      <h3>1. Особенности криптовалютных платежей</h3>
      <p>Оплата на платформе REALWORK может производиться с использованием цифровых активов (криптовалют) через встроенный платежный шлюз. Ввиду технологических особенностей распределенных сетей (блокчейн), все транзакции по отправке криптовалюты являются <strong>необратимыми</strong>. Возврат отправленных средств в автоматическом режиме технически невозможен.</p>
      
      <h3>2. Условия возврата и компенсаций</h3>
      <ul>
        <li>Если оплата была произведена, но услуга/баланс на платформе не были начислены из-за технического сбоя, Пользователь имеет право обратиться в службу поддержки REALWORK по адресу: <strong>support@yourdomain.com</strong> (укажи тут свой email).</li>
        <li>Каждое обращение рассматривается индивидуально в течение 24 часов. В случае подтверждения сбоя на стороне платформы, Администрация обязуется вручную зачислить оплаченную услугу или произвести компенсацию эквивалентной суммы.</li>
      </ul>
    </div>
  );
};

export default RefundPolicy;